import React, { Component, createElement as el } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as storage from '../lib/storage';
import {
  Base,
  Heading,
  Paragraph,
  Strong,
  Card,
  CardContent,
  ButtonGroup,
  Button
} from '@brandwatch/axiom-components';

import './Homescreen.css';

const sortByLastViewed = (a, b) => {
  return a.last_viewed_on.localeCompare(b.last_viewed_on);
};

const getIdHash = (ids, invite) => ids.concat(invite.invite_id_hash);

class CachedFallbackImage extends Component {
  constructor(props) {
    super(props);
    this.state = {useFallback: false, hide: false};
    this.onError = () => this.setState(this.state.useFallback ? {useFallback: true} : {hide: true});
  }
  render() {
    const {src, fallbackSrc, className} = this.props;
    const srcToUse = this.state.useFallback ? fallbackSrc : src;
    const style = {display: this.state.hide ? 'none' : 'block'};
    return <img src={srcToUse} style={style} onError={this.onError} className={className} />;
  }
}

CachedFallbackImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  fallbackSrc: PropTypes.string
};

CachedFallbackImage.defaultProps = {
  fallbackSrc: 'https://cdn.vizia.brandwatch.com/assets/thumbnails/annotation_text.svg'
};

class InviteCard extends Component {
  constructor(props) {
    super(props);

    const deck = storage.get('decks')[props.deck_id] || {};
    const first_component = storage.get('first_component_in_deck')[props.deck_id] || {};

    this.state = {deck, first_component};
  }

  render() {
    return (
      <div className="InviteCard">
        <Card shade="shade-1" size="small" border shadow>
          <Base className="ax-card__image">
            <CachedFallbackImage
              className="InviteCard__top-image"
              src={`https://cdn.vizia.brandwatch.com/assets/thumbnails/${this.state.first_component.component_type_id}.svg`}
            />
          </Base>
          <CardContent>
            <Heading textSize="headline">
              <Strong>{this.state.deck.name}</Strong>
            </Heading>
            <Paragraph className="InviteCard__message">{this.props.message}</Paragraph>
            <ButtonGroup>
              <Button Component={RouterLink} full="small" to={`/i/${this.props.invite_id_hash}?otp=${this.props.otp}`}>Open</Button>
            </ButtonGroup>
          </CardContent>
        </Card>
      </div>
    );
  }
}

InviteCard.propTypes = {
  deck_id: PropTypes.number,
  message: PropTypes.string,
  invite_id_hash: PropTypes.string,
  otp: PropTypes.string
};

class Homescreen extends Component {
  constructor(props) {
    super(props);

    const invites = storage.get('invites');

    this.state = {
      invites: invites,
      inviteOrder: Object.values(invites).sort(sortByLastViewed).reduce(getIdHash, [])
    };
  }

  render() {
    const cards = this.state.inviteOrder.map(id => el(InviteCard, Object.assign({key: id, history}, this.state.invites[id])));

    let heading;

    if (cards.length !== 0) {
      heading = 'Your Recently Opened Decks';
    } else {
      heading = 'You haven\'t opened any Decks recently.';
    }

    return (
      <div className="Homescreen">
        <Base className="Homescreen__inner" theme="night">
          <div className="Homescreen__heading">
            <Heading>{heading}</Heading>
          </div>
          <div className="Homescreen__decks">
            {cards}
          </div>
        </Base>
      </div>
    );
  }
}

Homescreen.propTypes = {
};

export default Homescreen;
